"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MACRO_TOKEN_TO_FORMAT_OPTS = exports.TWO_DIGIT = exports.LONG = exports.SHORT = exports.NUMERIC = void 0;
const format_types_1 = require("../types/format.types");
exports.NUMERIC = 'numeric', exports.SHORT = 'short', exports.LONG = 'long', exports.TWO_DIGIT = '2-digit';
const DATE_SHORT = {
    year: exports.NUMERIC,
    month: exports.TWO_DIGIT,
    day: exports.TWO_DIGIT,
};
const DATE_MED = {
    year: exports.NUMERIC,
    month: exports.SHORT,
    day: exports.TWO_DIGIT,
};
const DATE_FULL = {
    year: exports.NUMERIC,
    month: exports.LONG,
    day: exports.TWO_DIGIT,
};
const DATE_HUGE = {
    year: exports.NUMERIC,
    month: exports.LONG,
    day: exports.TWO_DIGIT,
    weekday: exports.LONG,
};
const TIME_SIMPLE = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
};
const TIME_WITH_SECONDS = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
};
const TIME_WITH_SHORT_OFFSET = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.SHORT,
};
const TIME_WITH_LONG_OFFSET = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.LONG,
};
const TIME_24_SIMPLE = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    hourCycle: 'h23',
};
const TIME_24_WITH_SECONDS = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    hourCycle: 'h23',
};
const TIME_24_WITH_SHORT_OFFSET = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    hourCycle: 'h23',
    timeZoneName: exports.SHORT,
};
const TIME_24_WITH_LONG_OFFSET = {
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    hourCycle: 'h23',
    timeZoneName: exports.LONG,
};
const DATETIME_SHORT = {
    year: exports.NUMERIC,
    month: exports.NUMERIC,
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
};
const DATETIME_SHORT_WITH_SECONDS = {
    year: exports.NUMERIC,
    month: exports.NUMERIC,
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
};
const DATETIME_MED = {
    year: exports.NUMERIC,
    month: exports.SHORT,
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
};
const DATETIME_MED_WITH_SECONDS = {
    year: exports.NUMERIC,
    month: exports.SHORT,
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
};
const DATETIME_FULL = {
    year: exports.NUMERIC,
    month: exports.LONG,
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    timeZoneName: exports.SHORT,
};
const DATETIME_FULL_WITH_SECONDS = {
    year: exports.NUMERIC,
    month: exports.LONG,
    day: exports.NUMERIC,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.SHORT,
};
const DATETIME_HUGE = {
    year: exports.NUMERIC,
    month: exports.LONG,
    day: exports.NUMERIC,
    weekday: exports.LONG,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    timeZoneName: exports.LONG,
};
const DATETIME_HUGE_WITH_SECONDS = {
    year: exports.NUMERIC,
    month: exports.LONG,
    day: exports.NUMERIC,
    weekday: exports.LONG,
    hour: exports.TWO_DIGIT,
    minute: exports.TWO_DIGIT,
    second: exports.TWO_DIGIT,
    timeZoneName: exports.LONG,
};
exports.MACRO_TOKEN_TO_FORMAT_OPTS = {
    [format_types_1.FORMAT_DATE.d]: DATE_SHORT,
    [format_types_1.FORMAT_DATE.dd]: DATE_MED,
    [format_types_1.FORMAT_DATE.ddd]: DATE_FULL,
    [format_types_1.FORMAT_DATE.dddd]: DATE_HUGE,
    [format_types_1.FORMAT_DATE.t]: TIME_SIMPLE,
    [format_types_1.FORMAT_DATE.tt]: TIME_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.ttt]: TIME_WITH_SHORT_OFFSET,
    [format_types_1.FORMAT_DATE.tttt]: TIME_WITH_LONG_OFFSET,
    [format_types_1.FORMAT_DATE.T]: TIME_24_SIMPLE,
    [format_types_1.FORMAT_DATE.TT]: TIME_24_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.TTT]: TIME_24_WITH_SHORT_OFFSET,
    [format_types_1.FORMAT_DATE.TTTT]: TIME_24_WITH_LONG_OFFSET,
    [format_types_1.FORMAT_DATE.f]: DATETIME_SHORT,
    [format_types_1.FORMAT_DATE.ff]: DATETIME_MED,
    [format_types_1.FORMAT_DATE.fff]: DATETIME_FULL,
    [format_types_1.FORMAT_DATE.ffff]: DATETIME_HUGE,
    [format_types_1.FORMAT_DATE.F]: DATETIME_SHORT_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.FF]: DATETIME_MED_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.FFF]: DATETIME_FULL_WITH_SECONDS,
    [format_types_1.FORMAT_DATE.FFFF]: DATETIME_HUGE_WITH_SECONDS,
};
//# sourceMappingURL=format.constant.js.map